import newMigrationRedux from 'Modules/importP4/views/main/.components/newMigration/redux/reducer';
import exceptionDetailsRedux from 'Modules/importP4/views/main/.components/exceptionDetails/redux/reducer';
//export redux objects
export default {
    newMigrationRedux,
    exceptionDetailsRedux,
};